import React from 'react'
import styled from 'styled-components'
import SkeletonBreadcrumb from '../../../../components/Breadcrumb/skeleton'
import { StyledContainerArticle0DetailArticle, StyledImageDetailArticle0DetailArticle } from './index'
import SkeletonHeaderDetailArticle from './components/HeaderDetailArticle/skeleton'
import SkeletonModifyAndShareDetailArticle from './components/ModifyAndShareDetailArticle/skeleton'
import SkeletonImageDetailArticle from './components/ImageDetailArticle/skeleton'
import TextSkeleton from '../../../../components/Text/views/TextSkeleton'
import isStolApp from '../../../../modules/is-stolapp'
import HeaderDetailArticle from './components/HeaderDetailArticle'

const Wrapper = styled.div``

const SkeletonDetailArticle = ({ routerState, ...props }) => (
  <Wrapper {...props}>
    {!isStolApp() && (
      <SkeletonBreadcrumb
        department={
          (routerState && routerState.department) ||
          (routerState && routerState.breadcrumb && routerState.breadcrumb.department)
        }
      />
    )}
    <StyledContainerArticle0DetailArticle>
      {routerState ? (
        <HeaderDetailArticle
          title={routerState && routerState.title}
          description={(routerState && routerState.text) || (routerState && routerState.description)}
          date={routerState && routerState.date}
          headline={
            (routerState && routerState.headline) ||
            (routerState && routerState.breadcrumb && routerState.breadcrumb.headline)
          }
          partner={routerState && routerState.partner}
        />
      ) : (
        <SkeletonHeaderDetailArticle />
      )}
      <SkeletonModifyAndShareDetailArticle />
      <StyledImageDetailArticle0DetailArticle as={SkeletonImageDetailArticle} />
      <TextSkeleton lines={5} fontSize="16px" lastWidth="45px" justify={false} />
      <TextSkeleton lines={3} fontSize="16px" lastWidth="65px" justify={false} />
      <SkeletonModifyAndShareDetailArticle position="bottom" />
    </StyledContainerArticle0DetailArticle>
  </Wrapper>
)

export default SkeletonDetailArticle
